"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_meta_1 = require("@shared/types/context-meta");
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('pr360RaterDisplayLogicService', [
        '$q',
        '$http',
        '$filter',
        'prActiveReport',
        'prDisplayLogicConstants',
        'rsEnvironment',
        'prDisplayLogicService',
        'pr.filters',
        'prFilterUtils',
        'pr.API_ROUTES',
        'pr.widgetManager',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'pr.WIDGET_MANAGER_EVENTS',
        'pr.customFilterUtils',
        'prFieldsets',
        function (
        // @ts-ignore
        $q, 
        // @ts-ignore
        $http, 
        // @ts-ignore
        $filter, 
        // @ts-ignore
        activeReport, 
        // @ts-ignore
        displayLogicConstants, 
        // @ts-ignore
        env, 
        // @ts-ignore
        displayLogicService, 
        // @ts-ignore
        prFilters, 
        // @ts-ignore
        filterUtils, 
        // @ts-ignore
        API_ROUTES, 
        // @ts-ignore
        widgetManager, 
        // @ts-ignore
        triggerOverrides, 
        // @ts-ignore
        OVERRIDE_EVENTS, 
        // @ts-ignore
        WIDGET_MANAGER_EVENTS, 
        // @ts-ignore
        customFilterUtils, fieldsetsService) {
            var translate = $filter('translate');
            var ID_PREFIX = 'RATER_DISPLAY_';
            var activeSurveyId = env.get(environment_1.ENV_VARS.ACTIVE_SURVEY_ID);
            function generateID() {
                return displayLogicService.generateIdHelper(ID_PREFIX);
            }
            function getNewDisplayLogic() {
                return {
                    _id: generateID(),
                    name: translate('PR.NEW_DISPLAY_LOGIC'),
                    type: "and" /* AND */,
                    children: [
                        displayLogicConstants.getBasicDisplayLogicObj()
                    ]
                };
            }
            function getDisplayLogics() {
                return lodash_1.default.cloneDeep(activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.RATER_DISPLAY_LOGICS) || []);
            }
            function getDisplayLogic(id) {
                var allDisplayLogics = getDisplayLogics();
                // @ts-ignore
                return lodash_1.default.find(allDisplayLogics, { _id: id });
            }
            function setDisplayLogics(displayLogics) {
                activeReport.setMetadata(context_meta_1.CONTEXT_META_VARS.RATER_DISPLAY_LOGICS, displayLogics);
                widgetManager.notifyAllWidgets(WIDGET_MANAGER_EVENTS.RATER_DISPLAY_LOGIC_CHANGED);
            }
            function getElementsForValidation() {
                return [
                    "rater" /* RATER */,
                    "operand" /* OPERAND */,
                    "operator" /* OPERATOR */
                ];
            }
            function getActionOptions() {
                var _a;
                return _a = {},
                    _a["show" /* SHOW */] = translate('PR.ACTION.SHOW'),
                    _a["hide" /* HIDE */] = translate('PR.ACTION.HIDE'),
                    _a;
            }
            function getItemOptions() {
                var _a;
                return lodash_1.default.merge((_a = {},
                    _a["entireReport" /* ENTIRE_REPORT */] = translate('PR.ENTIRE_REPORT'),
                    _a), getRaterOptions());
            }
            function getRaterOptions() {
                var raterFilters = getRaterFilters();
                var raterOptions = {};
                lodash_1.default.forEach(raterFilters, function (filter, filterId) {
                    raterOptions[filterId] = getFilterName(filter);
                });
                return raterOptions;
            }
            /**
             * In multi source report in dropdown with display logic filters may appear filters with the same name
             * from different sources, so we are adding information about source corresponding to each filter
             */
            function getFilterName(filter) {
                if (isMultipleSourceReport()) {
                    return lodash_1.default.get(filter, 'filterDef.filterName') + " (" + lodash_1.default.get(filter, 'filterDef.sourceName') + ")";
                }
                return lodash_1.default.get(filter, 'filterDef.filterName');
            }
            function isMultipleSourceReport() {
                var sourceIds = lodash_1.default.union.apply(lodash_1.default, lodash_1.default.values(activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.CONNECTED_SOURCES)));
                return sourceIds.length > 1;
            }
            /**
             * Get the filterIDs used in a single display logic
             */
            function getNestedDisplayLogicFilterIds(displayLogic) {
                return displayLogic.children
                    ? getDisplayLogicFilterIds(displayLogic.children)
                    // @ts-ignore
                    : [displayLogic.displayLogic.rater];
            }
            /**
             * Get the filterIDs used in the display logics
             */
            function getDisplayLogicFilterIds(displayLogics) {
                return displayLogics.flatMap(getNestedDisplayLogicFilterIds);
            }
            /**
             * Deletes the unused rater filters from the raterFilters object using breakout filter IDs from a dataConfig.
             * This improvement is only ran when the dataConfig is passed in from data-component.
             */
            function removeUnusedRaterFilters(raterFilters, dataConfig) {
                var raterFilterIdSet = new Set();
                var displayLogics = getDisplayLogics();
                var displayLogicFilterIDs = getDisplayLogicFilterIds(displayLogics);
                lodash_1.default.forEach(dataConfig.breakoutFilters, function (breakoutFilter) {
                    var filter = Object.values(breakoutFilter)[0];
                    raterFilterIdSet.add(filter.filterId);
                });
                displayLogicFilterIDs.forEach(function (filterId) {
                    raterFilterIdSet.add(filterId);
                });
                for (var filterId in raterFilters) {
                    if (!raterFilterIdSet.has(filterId)) {
                        delete raterFilters[filterId];
                    }
                }
            }
            /**
             * get all rater/relationship filters from custom filters and predefined filters
             */
            function getRaterFilters() {
                var fieldsets = fieldsetsService.getCachedFieldsets();
                var sourceIds = lodash_1.default.union.apply(lodash_1.default, lodash_1.default.values(activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.CONNECTED_SOURCES)));
                var raterFilters = {};
                var customFilters = activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.CUSTOM_FILTERS);
                // @ts-ignore
                var fieldSetIds = lodash_1.default.map(sourceIds, function (dataSource) { return lodash_1.default.get(fieldsets[dataSource], 'definition.fieldSetId'); }) || {};
                lodash_1.default.forEach(customFilters, function (filters, sourceId) {
                    if (!lodash_1.default.includes(fieldSetIds, sourceId)) {
                        return;
                    }
                    lodash_1.default.forEach(filters, function (filterDef, filterId) {
                        addToRaterFilters(raterFilters, filterDef, filterId, sourceId);
                    });
                });
                var predefined = activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.PREDEFINED);
                if (lodash_1.default.get(predefined, 'filters')) {
                    lodash_1.default.forEach(predefined.filters, function (filterDef) {
                        addToRaterFilters(raterFilters, filterDef, filterDef.filterId, activeSurveyId);
                    });
                }
                if (isMultipleSourceReport()) {
                    var sourceNameMap_1 = lodash_1.default.transform(env.get(environment_1.ENV_VARS.SOURCES), function (result, sourceInfo, sourceId) {
                        // @ts-ignore
                        result[lodash_1.default.get(fieldsets[sourceId], 'definition.fieldSetId')] = lodash_1.default.get(sourceInfo, 'name');
                        // @ts-ignore
                        result[sourceId] = lodash_1.default.get(sourceInfo, 'name');
                    });
                    lodash_1.default.forEach(raterFilters, function (filter) {
                        // @ts-ignore
                        var sourceName = sourceNameMap_1[lodash_1.default.get(filter, 'sourceId')];
                        lodash_1.default.update(filter, 'filterDef.sourceName', function () { return sourceName; });
                    });
                }
                return raterFilters;
            }
            function addToRaterFilters(raterFilters, filterDef, filterId, sourceId) {
                if (customFilterUtils.isRelationshipFilter(filterDef) && !raterFilters[filterId]) {
                    raterFilters[filterId] = {
                        sourceId: sourceId,
                        filterDef: filterDef
                    };
                }
            }
            function isEntireReportHidden() {
                return getHiddenRaters().then(function (hiddenRaters) {
                    return !!(hiddenRaters && hiddenRaters["entireReport" /* ENTIRE_REPORT */]);
                });
            }
            /**
             * Get hidden raters calculated based on display logics, override/report filters and widget filters
             * widgetFilters (optional) - widgetState.sharedData.dataConfig.filters
             */
            function getHiddenRaters(widgetFilters) {
                if (!shouldCalculateRaterDisplayLogic()) {
                    return $q.when();
                }
                var options = getRaterDisplayLogicParams(widgetFilters);
                return $http.post(API_ROUTES.THREE_SIXTY_RATER_DISPLAY_LOGIC, options)
                    // @ts-ignore
                    .then(function (response) {
                    return response.data;
                    // @ts-ignore
                }).catch(function (err) {
                    console.error('Could not get hidden raters: ', err);
                });
            }
            function shouldCalculateRaterDisplayLogic() {
                if (!shouldHaveRaterDisplayLogics()) {
                    return false;
                }
                var displayLogics = getDisplayLogics();
                if (!(displayLogics.length)) {
                    return false;
                }
                return true;
            }
            function shouldHaveRaterDisplayLogics() {
                var configFlags = triggerOverrides({
                    event: OVERRIDE_EVENTS.CONFIG_FLAGS,
                    sync: true,
                    data: {}
                });
                return configFlags.shouldHaveRaterDisplayLogic;
            }
            function getRaterDisplayLogicParams(widgetFilters) {
                var overrideFilters = prFilters.getOverrideFilters();
                fixFilters(overrideFilters);
                widgetFilters = widgetFilters || {};
                fixFilters(widgetFilters);
                return {
                    overrideFilters: overrideFilters,
                    widgetFilters: widgetFilters,
                    displayLogics: getDisplayLogics(),
                    raterFilters: getRaterFilters()
                };
            }
            function fixFilters(filters) {
                lodash_1.default.forEach(filters, function (filter) {
                    filterUtils.fixFilters(filter);
                });
            }
            return {
                generateID: generateID,
                getNewDisplayLogic: getNewDisplayLogic,
                getDisplayLogic: getDisplayLogic,
                getDisplayLogics: getDisplayLogics,
                setDisplayLogics: setDisplayLogics,
                getElementsForValidation: getElementsForValidation,
                getDisplayLogicFilterIds: getDisplayLogicFilterIds,
                getRaterOptions: getRaterOptions,
                getActionOptions: getActionOptions,
                getItemOptions: getItemOptions,
                getHiddenRaters: getHiddenRaters,
                isEntireReportHidden: isEntireReportHidden,
                getRaterDisplayLogicParams: getRaterDisplayLogicParams,
                shouldCalculateRaterDisplayLogic: shouldCalculateRaterDisplayLogic,
                removeUnusedRaterFilters: removeUnusedRaterFilters
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
